import { render, staticRenderFns } from "./LocationStore.vue?vue&type=template&id=674d4b94"
import script from "./LocationStore.vue?vue&type=script&lang=js"
export * from "./LocationStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports